import {createReducer, on } from '@ngrx/store'
import * as RpmActions from './rpm-page.actions'
import { initialRpmState } from './rpm-page.state';

export const rpmPageReducer = createReducer(
    initialRpmState,
    on(RpmActions.addPatientReport, (state, { reportId, report }) => ({
      ...state,
      report: { ...state.report, [reportId]: report }
    })),
on(RpmActions.addCorporations, (state, { corporations }) => ({ ...state, corporations: corporations })),
    on(RpmActions.addFacility, (state, { facility }) => {
        let allFacilities = [...state.facilities];
        allFacilities.push(facility);

        return {
            ...state,
            facilities: allFacilities
        }
    })
  );
